// CONFISCATION AND TERMINATION OF CONTRACT
import axios from "axios";
import Notification from "../../components/Air/Rampasan/Notification";
import SummaryCard from "../../components/Air/Rampasan/SummaryCard";
import UnitRampasanTable from "../../components/Air/Rampasan/Table";
import AdminLayout from "../../layout/AdminLayout";
import { useEffect, useState } from "react";

const Rampasan = () => {

    const [data,setData] = useState(null)

    const handleData = async () => {
        try {
            const res = await axios.get('https://bpohasil.ngrok.app/api/air-client')
            setData(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        handleData();
    },[])


    return(
        <AdminLayout>
             <div className="grid lg:grid-cols-2 my-5 gap-5">
                  {data &&  <SummaryCard data={data}/>}
                   <Notification/>
             </div>
           
             <div className="my-3">
                {data && <UnitRampasanTable data={data}/>}
             </div>
        </AdminLayout>
    );
}
export default Rampasan;